module.exports = __webpack_public_path__ + "static/img/logoOne.14923759.png";